import React, { useState} from "react";
import {useFetchPosts} from "../../features/post/postApi";
import PostListItem from "./PostListItem";
import PostListHeader from "./PostListHeader";
import PostButtons from "./PostButtons";

const PostList = () => {
    const [currentPage, setCurrentPage] = useState(1);
    // const [previousPage, setPreviousPage] = useState(currentPage);
    const [term, setTerm] = useState('');
    const {data: postsData} = useFetchPosts(currentPage,term); // if we will use a scroll then change a currentPage to previousPage
    // const [scrollLeft, setScrollLeft] = useState(0);
    const handleChange = (e: any) => {
        setTerm(e.target.value);
    };
    // useEffect(() => {
    //     setPreviousPage(currentPage);
    // }, [currentPage]);

    if (!postsData) {
        return <></>;
    }

    // const handleScroll = (e: any) => {
    //     setScrollLeft(e.target.scrollLeft);
    //     if (e.target.scrollLeft === 0) {
    //         if (currentPage > 1) {
    //             setTimeout(() => {
    //                 setCurrentPage(currentPage - 1);
    //             }, 4000);
    //         }
    //     } else if (e.target.scrollLeft === e.target.scrollWidth - e.target.clientWidth) {
    //         if (currentPage < postsData.last_page) {
    //             setTimeout(() => {
    //                 setCurrentPage(currentPage + 1);
    //             }, 500);
    //         }
    //     }
    // };

    return (
        <>
                <PostListHeader  />
            <input type="text" onChange={handleChange} style={{height: "20px"}}/>
            {/* if we used a scroll add this onScroll={handleScroll} */}
            <div style={{display: "flex", flexWrap: "nowrap", overflowX: "scroll"}} >
                {postsData.data
                    .filter((post) => post.title.toLowerCase().includes(term.toLowerCase()))
                    .map((post) => (
                        <PostListItem post={post} key={post.id}/>
                    ))}
            </div>
            <PostButtons currentPage={currentPage} setCurrentPage={setCurrentPage}/>
        </>
    );
};

export default PostList;
